import { IconProps } from '@/assets/types/icon'

const PassLogo = ({ className, ...props }: IconProps) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z"
        fill="#FF3A4A"
      />
      <path
        d="M28.79 16.8757C32.8695 17.1691 32.0743 20.247 32.2051 21.1736H29.8643L29.8438 20.1687C29.7443 18.3713 27.0208 18.3492 27.0264 20.4753C27.0264 22.0934 28.9323 22.8473 30.583 24.2703C32.592 26.2492 32.1064 26.5507 32.2051 27.5378C32.3372 29.9541 30.355 31.4084 27.709 31.0789C25.9165 30.9947 25.2439 29.6972 24.9688 29.2527C24.5485 28.5715 24.6921 27.6069 24.6641 26.8376H27.0547V27.7703C27.1012 29.47 30.0211 29.7486 29.8145 27.3679C29.7864 25.7217 26.8269 24.5495 25.8594 23.4617C23.7772 21.3843 23.9929 16.7775 28.79 16.8757ZM38.5781 16.8757C42.6575 17.1691 41.8624 20.247 41.9932 21.1736H39.6533L39.6318 20.1687C39.5324 18.3713 36.8089 18.3492 36.8145 20.4753C36.8145 22.0934 38.7204 22.8473 40.3711 24.2703C42.3801 26.2492 41.8945 26.5507 41.9932 27.5378C42.1253 29.9541 40.143 31.4084 37.4971 31.0789C35.7046 30.9947 35.032 29.6972 34.7568 29.2527C34.3366 28.5715 34.4802 27.6069 34.4521 26.8376H36.8428V27.7703C36.8893 29.47 39.8092 29.7486 39.6025 27.3679C39.5745 25.7217 36.6149 24.5495 35.6475 23.4617C33.5653 21.3843 33.781 16.7775 38.5781 16.8757ZM9.87012 16.9949C13.614 16.9949 13.2998 20.0106 13.2979 20.0291V23.698C13.2978 26.6972 10.2109 26.7253 10.2109 26.7253H8.21973V30.9949H6V17.0154C6 17.0154 7.11735 16.9949 9.87012 16.9949ZM22.9082 30.9949H20.5176L20.0635 28.5115H17.3525L16.8984 30.9949H14.5078L17.0117 16.9949H20.4043L22.9082 30.9949ZM17.5811 26.4187H19.8359L18.708 19.8865L17.5811 26.4187ZM8.21973 24.4646H9.89844C9.91931 24.4663 11.165 24.564 11.165 23.2224V20.3914C11.165 20.3914 11.1646 19.156 9.90527 19.156C8.66659 19.156 8.23351 19.1361 8.21973 19.1355V24.4646Z"
        fill="white"
      />
    </svg>
  )
}

export default PassLogo
